import React from "react";

import { Dialog } from "primereact/dialog";
const ModalCommisionGeral = ({ visible, onHide, commissionData }) => {
  return (
    <Dialog visible={visible} onHide={onHide} header="Comissão Cadastrada">
      <p>Informações da Comissão:</p>
      {commissionData ? (
        <ul>
          <li>Valor: {commissionData.value}</li>
          <li>Descrição: {commissionData.description}</li>
          {/* Adicione mais campos conforme necessário */}
        </ul>
      ) : (
        <p>Carregando...</p>
      )}
    </Dialog>
  );
};

export default ModalCommisionGeral;
